(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReservationPackageComponentDetails',
	};

	var $form;

	var _getPackageGroups,
	    _getAllInclusiveProperties;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$form = $(form.element);

		// Get package groups and all-inclusive properties when vendor is selected
		$('#reservationpackagecomponentdetails-supplier_vendor_id').on('change', function change(e) {
			_getPackageGroups($(this).val());
			_getAllInclusiveProperties($(this).val());
		});

		// Auto-adjust final payment soft date when final payment due date is set
		$('#reservationpackagecomponentdetails-final_payment_date').on('dp.change', function dateChange(event) {
			var $soft_payment_date      = $('#reservationpackagecomponentdetails-soft_payment_date'),
				soft_payment_date       = null,
				formatted_soft_date     = null,
				new_soft_payment_date   = null,
				formatted_new_soft_date = null;

			if (event.date) {
				soft_payment_date = $soft_payment_date.data('DateTimePicker');

				if (soft_payment_date && soft_payment_date.date()) {
					formatted_soft_date = soft_payment_date.date().format("M/D/YYYY");
				} else {
					formatted_soft_date = "(No date entered)";
				}

				new_soft_payment_date = event.date;
				new_soft_payment_date.subtract($soft_payment_date.data('soft-date-days'), 'days');
				formatted_new_soft_date = new_soft_payment_date.format('M/D/YYYY');

				Adzuki.CustomConfirm({
					title  : 'Change soft date?',
					content: 'Would you like to change the Final Soft Payment Date for this component from ' + formatted_soft_date + ' to ' + formatted_new_soft_date + ' (' + parseInt($soft_payment_date.data('soft-date-days')) + ' days before the Final Payment Date)? Click \'Yes\' to update the Final Payment Soft Date or \'No\' to keep the current Final Payment Soft Date.',
					confirm: function confirm() {
						soft_payment_date.date(new_soft_payment_date);
						return true;
					}
				});
			}
		});

		// Toggle manual group entry fields when manual option
		// is selected from package group drop-down
		$('#reservationpackagecomponentdetails-private_group_id').on('change', function onGroupIdChange(event) {
			if ($(event.target).val() === 'new') {
				$form.find('.create-group').removeClass('hidden');
			} else {
				$form.find('.create-group').addClass('hidden');
			}
		});

		// adjust the return date when the departure date changes
		$('#reservationpackagecomponentdetails-departure_date').on('dp.change', function onDepartureDateChange(event)
		{
			if (event.date) {
				$('#reservationpackagecomponentdetails-return_date')
					.data('DateTimePicker')
					.date(event.date);
			}
		});

		// if "Number of Lodging Properties" is present and changed, toggle disabled for hidden input
		$('#reservationpackagecomponentdetails-number_of_hotels').on('change', function onLodgingCountChange(event) {
			var disabled_state = true;

			if ($(this).val() > 0) {
				disabled_state = false;
			}

			$('#other_components_lodging_hidden').attr('disabled', disabled_state);
		});

		_getPackageGroups($('#reservationpackagecomponentdetails-supplier_vendor_id').val());
	};

	_getPackageGroups = function _getPackageGroups(vendor_id)
	{
		var $package_groups  = $('#reservationpackagecomponentdetails-private_group_id'),
		    private_group_id;

		$package_groups.empty();
		$package_groups.append($('<option>').text('--Not Part of a Group--').attr('value', ''));

		if (vendor_id === '') {
			return;
		}

		Adzuki.Ajax.get('/Reservations/getPackageGroups/' + vendor_id).then(function success(optgroups) {
			var optgroup,
			    sorted_data;

			$.each(optgroups, function loadOptgroup(key, value) {
				optgroup = $('<optgroup>');

				if (key !== '0') {
					optgroup.attr('label', key);

					sorted_data = Adzuki.Sort.alphabeticValue(value);

					$.each(sorted_data, function loadPackageGroup(i, package_group) {
						optgroup.append($('<option>').text(package_group.value).attr('value', package_group.key));
					});

					$package_groups.append(optgroup);
				}
			});

			if (typeof $package_groups.data('selected-id') !== 'undefined') {
				private_group_id = $package_groups.data('selected-id');
				$package_groups.removeAttr('data-selected-id');
				$package_groups.removeData('selected-id');

				$package_groups.val(private_group_id);

				$package_groups.trigger('change');
			}
		});
	};

	_getAllInclusiveProperties = function _getAllInclusiveProperties(vendor_id)
	{
		var $properties = $('#reservationpackagecomponentdetails-all_inclusive_property_id'),
		    property_id;

		$properties.empty();
		$properties.append($('<option>').text('').attr('value', ''));

		if (vendor_id === '') {
			$('#all_inclusive_property_row').addClass('hidden');
			return;
		}

		Adzuki.Ajax.get('/AllInclusiveProperties/getProperties/' + vendor_id).then(function success(properties) {
			var sorted_properties = Adzuki.Sort.alphabeticValue(properties);

			$.each(sorted_properties, function loadProperty(i, property) {
				$properties.append($('<option>').text(property.value).attr('value', property.key));
			});

			if (typeof $properties.data('selected-id') !== 'undefined') {
				property_id = $properties.data('selected-id');
				$properties.removeAttr('data-selected-id');
				$properties.removeData('selected-id');

				$properties.val(property_id);
			}
		});
	};

}(jQuery, window.Adzuki || {}));
